<template>
  <b-modal
    v-model="isShow"
    ok-variant="outline-secondary"
    :ok-title="$t('button.close')"
    centered
    size="lg"
    :hide-footer="true"
    @hide="isShow = false"
  >
    <div class="text-center">
      <template v-if="loading">
        <b-spinner type="grow" />
      </template>
      <iframe
        v-else-if="item.jokerUrl"
        :src="item.jokerUrl"
        class="w-100"
        style="aspect-ratio: 1"
        frameborder="0"
      />
    </div>
  </b-modal>
</template>

<script>
import { BModal, BSpinner } from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'

const BetHistoryRepository = Repository.get('betHistory')

export default {
  components: {
    BModal,
    BSpinner,
  },
  data() {
    return {
      loading: false,
      item: {},
      isShow: false,
    }
  },
  methods: {
    show(data) {
      this.item = {}
      this.isShow = true
      this.loading = true
      BetHistoryRepository.show({
        id: data.id,
      })
        .then(response => {
          const item = response.data.data
          this.item = {...item}
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        }).finally(() => {
          this.loading = false
        })
    },
    hide() {
      this.isShow = false
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
